webpackJsonp([208176855801404],{

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    throw new Error(prefix + ": " + (message || ''));
	}
	exports.default = invariant;


/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-pages-CaseStudy----CaseStudy-module---wrapper---Z6h9k","content":"src-components-pages-CaseStudy----CaseStudy-module---content---1WXhc","studyList":"src-components-pages-CaseStudy----CaseStudy-module---studyList---1Exz0","studyItem":"src-components-pages-CaseStudy----CaseStudy-module---studyItem---3XA9n","studyTitle":"src-components-pages-CaseStudy----CaseStudy-module---studyTitle---w3c-y"};

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(53);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(45);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CloudinaryImage = __webpack_require__(44);
	
	var _CloudinaryImage2 = _interopRequireDefault(_CloudinaryImage);
	
	var _CaseStudyModule = __webpack_require__(140);
	
	var _CaseStudyModule2 = _interopRequireDefault(_CaseStudyModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CaseStudy = function (_Component) {
	  _inherits(CaseStudy, _Component);
	
	  function CaseStudy(props) {
	    _classCallCheck(this, CaseStudy);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  CaseStudy.prototype.render = function render() {
	    var _props = this.props,
	        studies = _props.studies,
	        children = _props.children,
	        className = _props.className;
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_CaseStudyModule2.default.wrapper, className) },
	      _react2.default.createElement(
	        'div',
	        { className: _CaseStudyModule2.default.content },
	        children
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: _CaseStudyModule2.default.studyList },
	        studies.map(function (study, i) {
	          return _react2.default.createElement(
	            'li',
	            { key: i, className: _CaseStudyModule2.default.studyItem },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: study.link, className: _CaseStudyModule2.default.studyLink },
	              _react2.default.createElement(_CloudinaryImage2.default, {
	                imagePath: study.cover,
	                aspectRatio: 1 / 3,
	                options: {
	                  c: 'fill'
	                }
	              }),
	              _react2.default.createElement(
	                'h3',
	                { className: _CaseStudyModule2.default.studyTitle },
	                study.title
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return CaseStudy;
	}(_react.Component);
	
	CaseStudy.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  studies: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    link: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    cover: _propTypes2.default.string
	  }))
	};
	
	exports.default = CaseStudy;
	module.exports = exports['default'];

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"article":"src-components-pages-Testimonials----Testimonials-module---article---19BFH","quote":"src-components-pages-Testimonials----Testimonials-module---quote---3yAlP","quoteName":"src-components-pages-Testimonials----Testimonials-module---quoteName---2BKc7","quoteAddress":"src-components-pages-Testimonials----Testimonials-module---quoteAddress---3iGoP"};

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PageContent = __webpack_require__(31);
	
	var _PageContent2 = _interopRequireDefault(_PageContent);
	
	var _PageHeader = __webpack_require__(32);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _CaseStudy = __webpack_require__(114);
	
	var _CaseStudy2 = _interopRequireDefault(_CaseStudy);
	
	var _TestimonialsModule = __webpack_require__(425);
	
	var _TestimonialsModule2 = _interopRequireDefault(_TestimonialsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Testimonials = function Testimonials(_ref) {
	  var testimonials = _ref.testimonials;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_PageHeader2.default, { title: 'Testimonials' }),
	    testimonials.map(function (testimonial, i) {
	      return _react2.default.createElement(
	        _CaseStudy2.default,
	        {
	          studies: [{
	            link: testimonial.caseStudyLink,
	            title: testimonial.caseStudyTitle,
	            cover: testimonial.caseStudyCover
	          }],
	          key: i,
	          className: _TestimonialsModule2.default.article
	        },
	        _react2.default.createElement('blockquote', {
	          className: _TestimonialsModule2.default.quote,
	          dangerouslySetInnerHTML: { __html: testimonial.html }
	        }),
	        _react2.default.createElement(
	          'cite',
	          { className: _TestimonialsModule2.default.quoteName },
	          testimonial.name
	        ),
	        testimonial.address && _react2.default.createElement(
	          'h4',
	          { className: _TestimonialsModule2.default.quoteAddress },
	          testimonial.address
	        )
	      );
	    })
	  );
	};
	
	Testimonials.propTypes = {
	  testimonials: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.string,
	    address: _propTypes2.default.string,
	    html: _propTypes2.default.string
	  }))
	};
	
	exports.default = Testimonials;
	module.exports = exports['default'];

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(53);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Testimonials = __webpack_require__(305);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TestimonialPage = function TestimonialPage(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  var testimonialsData = data.allMarkdownRemark;
	  var pageSlug = pathContext.slug;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Testimonials2.default, {
	      testimonials: testimonialsData.edges.map(function (testimonial) {
	        return _extends({}, testimonial.node.frontmatter, { html: testimonial.node.html });
	      })
	    })
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = TestimonialPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-testimonials-js-f8c63062181c3f20a3ee.js